import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getActivities = ({
  version = 'v1',
  app,
  model,
  id,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${app}/${model}/${id}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCombinedActivities = ({
  version = 'v1',
  app,
  id,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/activity/activity/combined-comments/${app}/${id}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getCombinedActivitiesCount = ({
  version = 'v1',
  app,
  id,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/activity/activity/combined-comments/${app}/${id}/count`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getActivityReplies = ({
  version = 'v1',
  hashId,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${hashId}/replies/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createActivity = ({ version = 'v1', payload } = {}) =>
  client
    .request({
      url: `${version}/activity/activity/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateActivity = ({ version = 'v1', hashId, payload } = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${hashId}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const deleteActivity = ({ version = 'v1', hashId } = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${hashId}/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const likeActivity = ({ version = 'v1', hashId } = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${hashId}/like/`,
      method: RequestMethod.POST,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const unlikeActivity = ({ version = 'v1', hashId } = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${hashId}/unlike/`,
      method: RequestMethod.DELETE,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const replyToActivity = ({ version = 'v1', hashId, payload } = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${hashId}/reply/`,
      method: RequestMethod.POST,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getActivityLikers = ({ version = 'v1', hashId } = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${hashId}/likers/`,
      method: RequestMethod.GET,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getActivityIndex = ({
  version = 'v1',
  hashId,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/activity/activity/${hashId}/index/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const createActivityEntity = ({
  version = 'v1',
  entityType,
  params,
} = {}) =>
  client
    .request({
      url: `${version}/activity/activity-entities/`,
      method: RequestMethod.POST,
      data: { entityType },
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getUniqueStudentEntities = ({
  version = 'v1',
  app,
  model,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/activity/activity/unique-student-entities/${app}/${model}/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const getSchoolProfileCombinedActivitiesCount = ({
  version = 'v1',
  id,
  params = {},
} = {}) =>
  client
    .request({
      url: `${version}/activity/activity/combined-comments/school_profile/${id}/count/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
